import { Pipe, PipeTransform } from '@angular/core';

/**
 * @ngModule RISCommonModule
 */
@Pipe({
	name: 'cpBigItemsNumIndicationPipe',
	pure: true
})
export class BigItemsNumIndicationPipe implements PipeTransform {
	transform(val: number,biggerThanVal:number): string {
		if (val === null) {
			return "";
		}
		if (val >  biggerThanVal  ){
			return biggerThanVal.toString() + "+";
		}
		let strVal = val.toString();
		return strVal;

	}

}

